<template>
  <span :class="classes">
    <span v-if="!imgSrc && !icon" :class="`${prefixAvatarClass}__text`">{{ text }}</span>
    <img v-if="imgSrc && !icon" :class="`${prefixAvatarClass}__img`" :src="imgSrc">
    <i v-if="dot && !icon" :class="`${prefixAvatarClass}__dot`"></i>
    <t-icon v-if="icon=='user'" icon="user-outline" class="user"></t-icon>
  </span>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIX_AVATAR_CLASS = `${PREFIX_CLASS}avatar`

export default {
  name: 'TAvatar',
  props: {
    icon: {
      type: String,
      validator(value) {
        return ['', 'user']
      },
      default: ''
    },
    dot: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator(value) {
        return ['', 'lg'].includes(value)
      },
      default: ''
    },
    dotState: {
      type: String,
      validator(value) {
        return ['success', 'danger', 'warning', 'primary', 'info'].includes(
          value
        )
      },
      default: 'danger'
    },
    text: {
      type: String,
      default: ''
    },
    imgSrc: {
      type: String,
      default: ''
    },
    shape: {
      type: String,
      validator(value) {
        return ['circle', 'square']
      },
      default: 'circle'
    }
  },
  computed: {
    prefixAvatarClass() {
      return PREFIX_AVATAR_CLASS
    },
    classes() {
      return [
        `${this.prefixAvatarClass}`,
        {
          [`bg-${this.bgState}`]: !!this.bgState,
          [`${this.prefixAvatarClass}--${this.dotState}`]:
            this.dot && !!this.dotState,
          [`${this.prefixAvatarClass}--large`]: this.size === 'lg',
          [`${this.prefixAvatarClass}--${this.shape}`]: this.shape === 'square',
          [`${this.prefixAvatarClass}--${this.icon}`]: this.icon === 'user'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/avatar/avatar.vue